import React from "react";
import Icon from "@ant-design/icons";

export const ArrowRightIcon = (props) => {
   return (
      <Icon
         component={() => (
            <svg
               width="20"
               height="20"
               viewBox="0 0 20 20"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
            >
               <path
                  d="M2.54175 10.0013L17.5417 10.0013M17.5417 10.0013L10.8334 16.7097M17.5417 10.0013L10.8334 3.29297"
                  stroke="#5770CB"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
               />
            </svg>
         )}
         {...props}
      ></Icon>
   );
};
